<ng-container *transloco="let t">
    <div [ngSwitch]="status">
        <span *ngSwitchCase="MetodikaStatus.NotFound" class="text-warning">{{ t('Status of Metodika document synchronization (Metodica document status badge) - Not found') }}</span>
        <span *ngSwitchCase="MetodikaStatus.Draft" class="text-primary">{{ t('Status of Metodika document synchronization (Metodica document status badge) - Draft') }}</span>
        <span *ngSwitchCase="MetodikaStatus.Pending" class="text-muted">{{ t('Status of Metodika document synchronization (Metodica document status badge) - Pending') }}</span>
        <span *ngSwitchCase="MetodikaStatus.Sent" class="text-success">{{ t('Status of Metodika document synchronization (Metodica document status badge) - Sent') }}</span>
        <ng-container *ngSwitchCase="MetodikaStatus.Unsent">
            <div class="d-flex align-items-center">
                <span class="text-danger fw-bold">{{ t('Status of Metodika document synchronization (Metodica document status badge) - Unsent') }}</span>
                <app-metodika-retry-button [loading]="loading" (retry)="onRetry()">
                    {{ t('Status of Metodika document synchronization (Metodica document status badge) - Retry') }}
                </app-metodika-retry-button>
            </div>
        </ng-container>

        <span *ngSwitchDefault></span>
    </div>
</ng-container>